import { Pipe, PipeTransform } from '@angular/core';
import { EposFirstDay } from '../Model/EposFirstDay.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'EposFirstDayFilter',
  standalone: false
})
export class EposFirstDayFilterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(data: EposFirstDay[], searchTerm: string, field?: string): EposFirstDay[] {
    if (!data || !searchTerm?.trim()) return data;

    const lowerSearch = searchTerm.toLowerCase();

    return data.filter(item => {
      if (field && item[field] != null) {
        return this.formatValue(item[field]).includes(lowerSearch);
      }

      const fieldsToSearch = [
        this.datePipe.transform(item.LastUpdateDate, 'MMMM dd, yyyy'),
        this.datePipe.transform(item.applicationDate, 'MMMM dd, yyyy'),
        item.dayOfWeekId,
        item.UserName,
        item.marketCompanyName
      ];

      return fieldsToSearch.some(value => this.formatValue(value).includes(lowerSearch));
    });
  }

  private formatValue(value: any): string {
    return value != null ? value.toString().toLowerCase() : '';
  }
}
